(function () {
  const COOKIE = 'oma_inbox_opened';

  function hasOpenedChat() {
    return document.cookie.split(';').some(function (c) {
      return c.trim().startsWith(COOKIE + '=');
    });
  }

  function hideFakeBadge(shadowRoot) {
    if (hasOpenedChat()) return;

    const badge = shadowRoot.querySelector('[data-spec="notification-badge"]');
    if (badge && badge.textContent.trim() === '1') {
      badge.style.display = 'none';
    }
  }

  function setupChatWidget(chat) {
    if (!chat || !chat.shadowRoot || chat.dataset.inboxBadgeHidden === 'true') return false;

    const shadowRoot = chat.shadowRoot;
    hideFakeBadge(shadowRoot);

    const shadowObserver = new MutationObserver(function () {
      hideFakeBadge(shadowRoot);
    });
    shadowObserver.observe(shadowRoot, { childList: true, subtree: true });

    const toggle = shadowRoot.querySelector('[data-spec="toggle-button"]');
    if (toggle && !toggle.dataset.inboxBadgeListener) {
      toggle.dataset.inboxBadgeListener = 'true';
      toggle.addEventListener('click', function () {
        document.cookie = COOKIE + '=1; path=/; max-age=31536000; SameSite=Lax';
      });
    }

    chat.dataset.inboxBadgeHidden = 'true';
    return true;
  }

  function trySetup() {
    return setupChatWidget(document.getElementById('ShopifyChat'));
  }

  function init() {
    if (trySetup()) return;

    let attempts = 0;
    const retryInterval = setInterval(function () {
      attempts += 1;
      if (trySetup() || attempts >= 100) {
        clearInterval(retryInterval);
      }
    }, 100);

    const bodyObserver = new MutationObserver(function () {
      if (trySetup()) {
        bodyObserver.disconnect();
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
